import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import EditCode from '@wikifactory/slate-edit-code';

import { NodeHotKey } from 'libs/editor/plugins/helpers/nodeHotKey';
import { RenderNode } from 'libs/editor/plugins/helpers/renderNode';

const CodeBlockNode = observer(({ attributes, children }) => (
  <CodeBlockStyle className='code' {...attributes}>
    {children}
  </CodeBlockStyle>
));

const CodeBlockStyle = styled.div`
  padding: 4px;
  background-color: ${props => props.theme.color.wfGrey200};
  border: 1px solid ${props => props.theme.color.wfGrey300};
  color: ${props => props.theme.color.wfGrey};
  width: 100%;
  display: block;
  overflow-x: scroll;
`;

const type = 'code_block';
const codePlugin = EditCode({
  containerType: type,
  lineType: 'code_line',
  selectAll: true,
});
const active = value => value.startKey && codePlugin.utils.isInCodeBlock(value);

export function CodeBlock() {
  return {
    button: {
      elementType: 'node',
      type,
      active,
      handleClick: store => {
        const { value, reference, onChange } = store;
        if (active(value)) {
          codePlugin.changes.unwrapCodeBlock(reference, 'paragraph');
        } else {
          codePlugin.changes.wrapCodeBlock(reference, type);
        }
        onChange(reference);
      },
    },
    plugins: [
      NodeHotKey({ key: '', type: 'code_block' }),
      RenderNode('code_block', props => <CodeBlockNode {...props} />),
      codePlugin,
    ],
  };
}
